import { FarmingIcon, FeesIcon, VoteIcon } from "@/domains/icons"

import type { ComplexTab } from "../complex-breadcrumb-dropdown"
import { ComplexBreadcrumbItem } from "../../types/complex-breadcrumb-item"
import { ComplexBreadcrumbDropdown } from "../complex-breadcrumb-dropdown"

// Available Rewards pages
export const REWARDS_PAGES: ComplexTab[] = [
  {
    id: "farming",
    label: "Farming Rewards",
    tabLabel: "Farming",
    description: "Claim your farming rewards",
    slug: "/rewards",
    icon: FarmingIcon,
  },
  {
    id: "fees",
    label: "Earned Fees",
    tabLabel: "Fees",
    description: "Claim your earned fees",
    slug: "/rewards/fees",
    icon: FeesIcon,
  },
  {
    id: "voting",
    label: "Voting Rewards",
    tabLabel: "Voting",
    description: "Claim your voting rewards",
    slug: "/rewards/voting",
    icon: VoteIcon,
  },
] as const

export const RewardsPagesComplexBreadcrumbApplication: ComplexBreadcrumbItem = {
  type: "complex",
  application: "rewards-pages",
  render: () => <RewardsPagesComplexBreadcrumbApplicationComponent />,
}

/**
 * Complex breadcrumb application for Rewards pages
 * Shows current page name and allows navigation to other Rewards pages
 */
export const RewardsPagesComplexBreadcrumbApplicationComponent = () => {
  return (
    <ComplexBreadcrumbDropdown tabs={REWARDS_PAGES} navigationMode="path" invalidTabMessage="Invalid rewards page" />
  )
}
